export default __webpack_public_path__ + "static/media/video.21760dd9.mp4";